module.exports = __webpack_public_path__ + "img/1.b7d1b5eb.jpg";